import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import OrderReturnListWrap from '../../views/order/return/list/OrderReturnListWrap';
import { orderActions } from '../../store/modules/order';
import {
  ORDER_RETURN_LIST_FILTER_OPTION_MODEL,
  ORDER_RETURN_LIST_SEARCH_DATA_MODEL,
  ORDER_RETURN_LIST_SEARCH_OPTION_MODEL,
  ORDER_RETURN_LIST_SORT_OPTION_MODEL,
} from '../../store/modules/order/models';
import { LIST_PAGINATION_MODEL } from '../../store/modules/app/models';
import { NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT } from '../../constants/service/common/utilConstants';

class OrderReturnListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    const { setData } = this.props;
    this.getList({
      searchOption: ORDER_RETURN_LIST_SEARCH_OPTION_MODEL,
      filterOption: ORDER_RETURN_LIST_FILTER_OPTION_MODEL,
      sortOption: ORDER_RETURN_LIST_SORT_OPTION_MODEL,
      pagination: LIST_PAGINATION_MODEL,
    });

    /**
     *  검색 박스 초기화
     */
    setData({
      path: ['orderReturnList', 'searchData'],
      value: ORDER_RETURN_LIST_SEARCH_DATA_MODEL,
    });
  };

  getList = (data) => {
    const { getOrderReturnList, orderReturnList } = this.props;
    const { searchOption, filterOption, sortOption, pagination } = orderReturnList;

    getOrderReturnList({
      searchOption,
      filterOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  /**
   * 엑셀 다운로드
   */
  getExcelDownload = () => {
    const { getOrderReturnListExcelDownload, pageName, orderReturnList, adminInfo } = this.props;

    if (!orderReturnList || !orderReturnList.list.length) {
      message.error(NO_DATA_ON_EXCEL_DOWNLOAD_WARNING_TEXT);
      return;
    }

    getOrderReturnListExcelDownload({
      email: adminInfo.email,
      searchOption: orderReturnList.searchOption,
      filterOption: orderReturnList.filterOption,
      sortOption: orderReturnList.sortOption,
      orderPageName: pageName,
    });
  };

  render() {
    const { setData, orderReturnList, mainProductCategorySelectList } = this.props;

    return (
      <OrderReturnListWrap
        setData={setData}
        orderReturnList={orderReturnList}
        mainProductCategorySelectList={mainProductCategorySelectList}
        getList={this.getList}
        getExcelDownload={this.getExcelDownload}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminInfo: state.app.adminInfo,
    orderReturnList: state.order.orderReturnList,
    mainProductCategorySelectList: state.order.mainProductCategorySelectList,
  };
};

const mapDispatchToProps = {
  setData: orderActions.setData,
  getOrderReturnList: orderActions.getOrderReturnList,
  getOrderReturnListExcelDownload: orderActions.getOrderReturnListExcelDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderReturnListContainer);
